class PagerController {
    constructor($scope) {

        "ngInject";

        var self = this;
        this.pageToShow = [];
        this.update();

        $scope.$watch(() => {
            return self.current;
        }, () => {
            self.update();
        });
        $scope.$watch(() => {
            return self.total;
        }, () => {
            self.update();
        });
    }

    prev() {
        if (this.current == 1)
            return;

        this.loadPage(this.current - 1);
    }

    next() {
        if (this.current == this.total)
            return;

        this.loadPage(this.current + 1);
    }

    loadPage(page) {
        if(page==='...')return;
        this.current = page;
        this.load({page: page});
        $('#goToPage-number').blur()
        $(document).scrollTop(0);
        this.update();
    }

    update() {

        this.pageToShow = [];
        if (this.current <= 2) {
            for (var i = 1; i <= this.total && i <= 3; i++) {
                this.pageToShow.push(i);
            }
            if(this.total>3){
                if(this.total==4){
                    this.pageToShow=this.pageToShow.concat([this.total])
                }else{
                    this.pageToShow=this.pageToShow.concat(['...',this.total])
                }
            }
        } else if (this.current >= this.total - 1) {
            for (var i = this.total, c = 0; c < 3 && i > 0; i--, c++) {
                this.pageToShow.unshift(i);
            }
            if(this.total>3){
                if(this.total==4){
                    this.pageToShow=[1].concat(this.pageToShow)
                }else{
                    this.pageToShow=[1,'...'].concat(this.pageToShow)
                }
            }
        } else {
            this.pageToShow = [
                this.current - 1,
                this.current,
                +this.current + 1
            ];
            if(this.total>3){
                if(this.total==5){
                    this.pageToShow=[1].concat(this.pageToShow).concat([this.total])
                }else{
                    if(this.current==3){
                        this.pageToShow=[1].concat(this.pageToShow).concat(['...',this.total])
                    }else if(this.current==this.total-2){
                        this.pageToShow=[1,'...'].concat(this.pageToShow).concat([this.total])
                    }else{
                        this.pageToShow=[1,'...'].concat(this.pageToShow).concat(['...',this.total])
                    }

                }
            }
        }
        // if(window.innerWidth<767){
        //
        // }else{
        //     if (this.current <= 3) {
        //         for (var i = 1; i <= this.total && i <= 5; i++) {
        //             this.pageToShow.push(i);
        //         }
        //         this.total>5 && (this.pageToShow=this.pageToShow.concat(['...',this.total]))
        //     } else if (this.current >= this.total - 2) {
        //         for (var i = this.total, c = 0; c < 5 && i > 0; i--, c++) {
        //             this.pageToShow.unshift(i);
        //         }
        //         this.total>5 && (this.pageToShow=[1,'...'].concat(this.pageToShow))
        //     } else {
        //         this.pageToShow = [
        //             this.current - 2,
        //             this.current - 1,
        //             this.current,
        //             +this.current + 1,
        //             +this.current + 2
        //         ];
        //         this.total>5 && (this.pageToShow=[1,'...'].concat(this.pageToShow).concat(['...',this.total]))
        //     }
        // }


    }
}

export default PagerController;



// WEBPACK FOOTER //
// ./src/app/common/pager/pager.controller.js